/* ENSO effects: live Singapore clock, frosted header on scroll, palette alignment for Section Store app blocks. */
(function () {
  if (window.__ensoFx) return;
  window.__ensoFx = 1;

  var html = document.documentElement;

  /* Singapore time, HH:MM */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function sgt() { var d = new Date(); return new Date(d.getTime() + d.getTimezoneOffset() * 60000 + 8 * 3600000); }
  function tick() {
    var t = sgt(), s = pad(t.getHours()) + ':' + pad(t.getMinutes());
    var els = document.querySelectorAll('[data-enso-clock]');
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== s) els[i].textContent = s;
  }

  /* header state */
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; html.classList.toggle('enso-scrolled', window.scrollY > 24); });
  }

  /* Section Store app blocks render inside shadow DOM and re-apply their own inline colours and corners,
     so theme CSS cannot reach them and a one-off recolour gets overwritten. Inject one stylesheet into each
     shadow root instead: author !important rules beat the app's inline values on every re-render.
     The proper fix is the block settings in each product template; this keeps them on palette meanwhile. */
  var SHADOW_CSS =
    '.body,.cards{border-radius:0!important;border-color:#e6e3dc!important;--icon-color:#333333!important}' +
    '.icon svg path,.icon svg circle,.indicator svg circle,.indicator svg path{fill:#333333!important}' +
    '.indicator .default{animation:none!important}';
  function alignAppBlocks() {
    var els = document.querySelectorAll('section-store--benefits-list-block, section-store--benefits-boxes-block, section-store--shipping-info-block');
    Array.prototype.forEach.call(els, function (el) {
      var root = el.shadowRoot; if (!root || root.getElementById('enso-align')) return;
      var st = document.createElement('style'); st.id = 'enso-align'; st.textContent = SHADOW_CSS;
      root.appendChild(st);
    });
  }

  /* only text boxes that already sit on a solid panel become glass; plain text over a photo stays as it is */
  function markGlassBoxes(scope) {
    var els = (scope || document).querySelectorAll('.text-overlay__text:not(.enso-glass-box):not([data-enso-checked])');
    Array.prototype.forEach.call(els, function (el) {
      el.dataset.ensoChecked = '1';
      var m = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
      if (m && (m.length < 4 || parseFloat(m[3]) > 0.2)) el.classList.add('enso-glass-box');
    });
  }

  function init() {
    tick(); setInterval(tick, 1000);
    markGlassBoxes(document);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    alignAppBlocks();
    var tries = 0, t = setInterval(function () { alignAppBlocks(); if (++tries > 20) clearInterval(t); }, 500);
    new MutationObserver(function () { alignAppBlocks(); }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { tick(); alignAppBlocks(); markGlassBoxes(e.target); });
})();
